import { createContext, useReducer, Dispatch, FC } from 'react';
import { IAccountInfo } from '../models/AuthModel';


const initialState: IAccountInfo | null = null;

// Definimos las acciones
export enum ActionType {
  SET_USER = 'SET_USER',
}

type Action = {
  type: ActionType.SET_USER;
  payload: IAccountInfo | null;
};

// Definimos el reducer
const reducer = (state: any, action: Action): any => {
  if(action.type === ActionType.SET_USER) {
    return {...action.payload}
  } 
  return state
};

// Creamos el contexto
export const UserContext = createContext<[IAccountInfo | null, Dispatch<any>]>([
  initialState,
  () => null,
]);

// Creamos el provider que proveerá el contexto
export const UserProvider: FC<any> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <UserContext.Provider value={[state, dispatch]}>
      {children}
    </UserContext.Provider>
  );
};

